export default __webpack_public_path__ + "static/media/alkem.e5010d73.png";